import * as THREE from "three";

import { EdgeIndex } from "../enum/EdgeIndex";
import type { Rect } from "./Rect";

export class RectSizeHelper {
  public size: THREE.Vector2;
  public offset: THREE.Vector2;
  private rect: Rect;
  private inner: boolean;
  constructor(rect: Rect, inner = true) {
    this.inner = inner;
    this.rect = rect;
    this.size = inner ? rect.innerSize.clone() : rect.outerSize.clone();
    this.offset = new THREE.Vector2();
  }
  public expand(side: EdgeIndex, amount: number) {
    this.shrink(side, -amount);
  }
  public shrink(side: EdgeIndex, amount: number) {
    const dim2d = (side & 1) === 0 ? "x" : "y";
    // tslint:enable:no-bitwise
    this.size[dim2d] -= amount;
    if (side === EdgeIndex.RIGHT || side === EdgeIndex.TOP) {
      this.offset[dim2d] -= amount / 2;
    } else {
      this.offset[dim2d] += amount / 2;
    }
  }
  public get innerPos3d(): THREE.Vector3 {
    const { verticalDir, horizontalDir } = this.rect.properties;
    return (
      this.inner ? this.rect.innerCenter.clone() : this.rect.outerCenter.clone()
    )
      .add(horizontalDir.clone().multiplyScalar(this.offset.x))
      .add(verticalDir.clone().multiplyScalar(this.offset.y));
  }
  public get pos3d(): THREE.Vector3 {
    const { verticalDir, horizontalDir } = this.rect.properties;
    return (
      this.inner ? this.rect.center.clone() : this.rect.outerCenter.clone()
    )
      .add(horizontalDir.clone().multiplyScalar(this.offset.x))
      .add(verticalDir.clone().multiplyScalar(this.offset.y));
  }
}
